<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3MPCSr/tc-custom/9781400217595.jpg?1703909327317" alt="This image is the cover for the book 100 Favorite Bible Prayers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">100 Favorite Bible Prayers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>With prayers for healing, peace, and strength for today, <i>100 Favorite Bible Prayers </i>invites you to rest in God's presence as you develop the practice of praying through the great prayers of the Bible.</b></p><p>Discover the life-changing power of conversation with God as you immerse yourself in the richest prayers of the Old and New Testaments<i>. </i>From Hannah's prayers for a child to Jesus' prayer in Gethsemane, the prayers of Scripture remind us of God's longing for us to draw near to Him. Inside this beautiful gift book, you’ll find:</p>Each prayer paired with a brief devotion to help you understand the Scripture context and learn how to apply the prayers in your own lifeFour-color botanical-themed illustrations and lovely typography lines on every page<p><i>100 Favorite Bible Prayers </i>will help women create the habit of praying Scripture. The prayers can be a great way start each day or a pleasant way to relax and spend quiet time with the Lord each evening. This is a gorgeous gift for birthdays, gift giving holidays, or for a friend wanting to grow deeper in his or her relationship with God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stacy Edwards
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?510b3cad